export default __webpack_public_path__ + "static/media/image17.fafcd86e.svg";